import { useContext } from "react";
import { WplywContext } from "../../../../../context/wplywContext";
import { useActiveTab } from "../../../../../context/activeTabContext";
export function useCheckStages() {
    const { wplyw } = useContext(WplywContext); // Proper use of useContext inside a custom hook
    const {activeTabX} = useActiveTab()
    const {activeKey, innerActiveKey, personid} = activeTabX

    if(activeKey == '2'){
        return null;
    } else {
        if(activeKey == '1'){
            return {name: "dane", activeKey, innerActiveKey, personid};
        } else if(activeKey == '3') {
            if(innerActiveKey == '1'){
                return {name: "kwoty", activeKey, innerActiveKey, personid};
            }
            if(innerActiveKey == '2'){
                return {name: "rachunki", activeKey, innerActiveKey, personid};
            }
            return null;
        }
    }

}
